import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from "@angular/core"
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR } from "@angular/forms"
import { ChangePasswordModalComponent } from "../../shared-components/modals/change-password-modal/change-password-modal.component"
import { ModalService } from "../../shared-components/modal/modal.service"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-account-info",
    templateUrl: "./account-info.component.html",
    styleUrls: ["./account-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AccountInfoComponent),
            multi: true,
        },
    ],
})
export class AccountInfoComponent implements ControlValueAccessor, OnInit {
    @Input()
    set userProfile({ hasPBSAccount }) {
        this.hasPBSAccount = hasPBSAccount
    }

    hasPBSAccount = false
    accountInfo = this.fb.group({
        email: [""],
        password: [""],
    })

    constructor(
        public userService: UserService,
        private fb: FormBuilder,
        private modalService: ModalService
    ) {}

    ngOnInit() {
        this.accountInfo.disable()
    }

    writeValue(value: { email: string; password: string }): void {
        this.accountInfo.patchValue(value)
    }

    registerOnChange(fn: any): void {
        this.accountInfo.valueChanges.subscribe(fn)
    }

    registerOnTouched(fn: any): void {}

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            return this.accountInfo.disable()
        }
        //this will enable the email and pass fields, for the moment those fields should not be editable
        // this.accountInfo.enable()
    }

    clickChangePassword() {
        this.modalService.open(ChangePasswordModalComponent)
    }
}
